import { isPropertyCodeIdentifier } from "./posthog-capture.ts";

/** Reject common direct identifiers from bounded campaign labels before transport. */
export function safeCheckoutCampaignTag(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const tag = value.trim().replace(/\s+/g, " ");
  if (!tag || tag.length > 120) return undefined;
  // This is a conservative shape filter, not proof that arbitrary free text
  // is public. Numeric contact IDs and address-like labels are dropped; a
  // year-prefixed campaign phrase with a marketing term remains measurable.
  const phoneShaped = /^(?:1[-. ]?)?(?:\d{3}[-. ]?){2}\d{4}$/.test(tag);
  const looksLikeStreetAddress = /^\d{1,6} (?:[A-Za-z0-9.-]+ ){0,5}(?:St|Street|Ave|Avenue|Rd|Road|Dr|Drive|Blvd|Boulevard|Ln|Lane|Ct|Court|Pl|Place|Way)\b/i.test(tag);
  const yearPrefixedCampaign = /^(?:19|20)\d{2} .+\b(?:tax|appeal|assessment|search|campaign|adgroup|packet)\b/i.test(tag);
  const numericLeadingAddress = /^\d{1,6}(?:[A-Za-z]|-\d{1,6})? [A-Za-z]/.test(tag) && !yearPrefixedCampaign;
  if (!/^[A-Za-z0-9 _.-]+$/.test(tag) ||
      /^\d+$/.test(tag) ||
      phoneShaped ||
      looksLikeStreetAddress ||
      numericLeadingAddress ||
      isPropertyCodeIdentifier(tag)) return undefined;
  return tag;
}
